import React from "react";

function ImageGrid({ images, onImageClick }) {
    if (!images || images.length === 0) {
        return (
            <div className="empty-state">
                <h3>No images for this date</h3>
                <p>Camera captures will appear here when available.</p>
            </div>
        );
    }

    return (
        <div className="image-grid">
            {images.map((img, i) => (
                <div
                    key={i}
                    className="image-grid-item"
                    onClick={() => onImageClick && onImageClick(i)}
                >
                    <img
                        src={img.url}
                        alt={img.filename}
                        className="image-grid-thumb"
                        onError={(e) => { e.target.style.display = "none"; }}
                    />
                    <div className="image-grid-info">
                        <div className="image-grid-zone">{img.zone}</div>
                        <div className="image-grid-time">
                            {img.capturedAt ? new Date(img.capturedAt).toLocaleTimeString() : img.filename}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ImageGrid;
